function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#EFF1F2",
  transform: "translate(136)"
}, React.createElement("ellipse", {
  cx: 3.238,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 3.238,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 11.331,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 168.354,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 176.448,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 63.133,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 71.227,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 229.867,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 236.343,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 124.646,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 131.122,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 288.144,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 19.425,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 25.901,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 182.923,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 192.635,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 77.702,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 87.414,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 244.436,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 250.912,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 139.215,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 145.691,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 32.376,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 40.47,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 199.11,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 207.204,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 93.89,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 100.365,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 260.624,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 267.099,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 155.403,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 161.878,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 48.564,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 56.657,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 213.68,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 220.155,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 108.459,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 114.934,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 3.232,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 184.203,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 92.102,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 273.073,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 17.774,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 197.13,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 108.26,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 33.932,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 213.288,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 122.802,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 48.475,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 227.831,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 138.96,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 64.633,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 242.373,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 275.193,
  cy: 153.503,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 79.175,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 258.531,
  rx: 3.238,
  ry: 3.232
}), React.createElement("ellipse", {
  cx: 281.669,
  cy: 168.045,
  rx: 3.238,
  ry: 3.232
})), React.createElement("rect", {
  width: 132,
  height: 132,
  x: 70,
  y: 207,
  fill: "#0097DC",
  opacity: 0.065
}), React.createElement("rect", {
  width: 46,
  height: 46,
  y: 150,
  fill: "#0097DC",
  opacity: 0.041
}));

var SvgDots2 = function SvgDots2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 428,
    height: 339,
    viewBox: "0 0 428 339",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDots2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots2.e4cbf308.svg";
export { ForwardRef as ReactComponent };